import { render, staticRenderFns } from "./confirm-message.vue?vue&type=template&id=17ab5eb9&"
import script from "./confirm-message.vue?vue&type=script&lang=js&"
export * from "./confirm-message.vue?vue&type=script&lang=js&"
import style0 from "./confirm-message.vue?vue&type=style&index=0&id=17ab5eb9&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports